module.exports = __webpack_public_path__ + "static/lsc2021-bronze-b75ba30d933a051b79dec5d1e5eaab7c.png";